import { Fragment, ReactElement, useState } from 'react';

import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Stack } from '@mui/material';
import { useStore } from 'zustand';

import { SearchBar, StyledContentLayout } from '@/components';

import { AddUserDrawer, UserTable } from '../components';
import { usersStore } from '../store';

export const UserSettings = (): ReactElement => {
  const { setSearchString } = useStore(usersStore);

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleSave = () => {
    void setOpenDrawer(true);
  };

  return (
    <Fragment>
      <Box bgcolor="#FFF" height="100%">
        <StyledContentLayout fixedHeight>
          <Stack
            width="100%"
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box sx={{ flexGrow: 1 }}>
              <SearchBar
                placeholder="Search..."
                onChangeSearchString={setSearchString}
              />
            </Box>
            <PrimaryButton
              sx={{ minWidth: 95, textTransform: 'none' }}
              onClick={handleSave}
            >
              Add User
            </PrimaryButton>
          </Stack>
          <UserTable />
        </StyledContentLayout>
        <AddUserDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
      </Box>
    </Fragment>
  );
};
